module.exports = __webpack_public_path__ + "img/selected4-min.a6f54f1b.png";